;(function () {
  'use strict'
  angular.module('obex').factory('agentsService', [
    '$rootScope',
    '$http',
    'authService',
    function ($rootScope, $http, authService) {
      return {
        getOnlineAgents() {
          var loginMember = authService.getLoginMember()
          console.log(
            'call authService.getLoginMember() in alert.service ',
            loginMember,
          )
          return $http.get('/getOnlineAgents/' + loginMember.OrganizationId)
        },
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./client/js/services/agents.service.js